<template>
    <div class="panel">
        <div class="head">
            <span class="title">基础权限</span>
        </div>
        <!--基础权限列-->
        <div class="auth-list _user_auth_list">
            <div class="auth-block" v-for="(item,index) in authList">
                <label class="auth-title" ><span style="cursor: pointer" @click="selectBlock(index)">{{item.title}}</span></label>
                <CheckboxGroup v-model="userAuth">
                    <Checkbox v-for="auth in authList[index].authList" :label="auth.value" :key="auth.value">{{auth.name}}</Checkbox>
                </CheckboxGroup>
            </div>
            <div class="auth-btn">
                <Button type="primary" :loading="loading3" @click="saveBaseAuth">保存</Button>
            </div>
        </div>
    </div>
</template>

<script>
    import baseAuth from '@/staticData/baseAuth';
    import $api from "@/service/index";
    import utils from "@/utils";

    export default {
        props :{
            uid : String,
        },
        data(){
            return {
                loading3 : false,
                //权限候选项
                authList : baseAuth,
                //用户具有的权限
                userAuth : [],
            }
        },
        created(){
            this.getUserAuth();
        },
        methods : {
            //刷新页
            refresh(){
                this.$emit("refresh");
            },
            //组选中
            selectBlock(index){
                let _self = this;
                let allIndex = this.authList[index].checkAll;

                //判断交集是否等于本类全部
                if([...new Set([...new Set(_self.userAuth)].filter(x=>new Set(allIndex).has(x)))].sort().toString() === allIndex.sort().toString()){
                    //全不选[差集]
                    this.userAuth = [...new Set([...new Set(_self.userAuth)].filter(x=>!new Set(allIndex).has(x)))];
                }else{
                    //全选[合并]
                    this.userAuth = [...this.userAuth,...allIndex];
                    this.userAuth = Array.from(new Set(_self.userAuth));
                }
            },
            //获取用户所具有的权限
            getUserAuth(){
                let _self = this;
                $api.getUserBaseAuth(_self.uid).then(data=>{
                    _self.userAuth = data;
                });
            },
            //保存用户权限
            saveBaseAuth(){
                this.loading3 = true;
                let _self = this;
                $api.setUserBaseAuth(_self.uid,_self.userAuth).then(data=>{
                    if(data.code==="200"){
                        _self.loading3 = false;
                        // utils.notice("保存成功","success");
                        utils.message({title: "保存成功"}, 'success');
                        _self.getUserAuth();
                        this.$emit("refresh");
                    }else{
                        _self.loading3 = false;
                        // utils.notice(data.msg,"error");
                        utils.message({title: data.msg}, 'error');
                    }
                });
            },
        }
    }
</script>

<style scoped>
    @import "usereBaseAuth.less";
</style>
<style>
    /*此style所有内容必须包裹_user_auth_list以防css污染*/
    ._user_auth_list .ivu-checkbox-wrapper{
        padding-bottom: 10px;
        padding-right: 30px;
    }
    ._user_auth_list .ivu-checkbox-wrapper .ivu-checkbox-inner{
        width : 20px ;
        height: 20px;
    }
    ._user_auth_list .ivu-checkbox-checked .ivu-checkbox-inner:after{
        top : 2px;
        left: 6px;
        width: 6px;
        height: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/company/member/business/UserBaseAuth.vue